import Hero_section from "../Blc_Home/Hero_Section/Hero_section";
import Contact from './Contact/Contact';
import Hero_Section_Contact from './Hero_Section_Contact/Hero_Section_Contact';
import Blc_partner from "../Blc_Home/Blc_partner/Blc_partner";
import { Helmet } from "react-helmet";

const Blc_Contact = (props) => {

    return (
        <div>
            <Helmet>
                <title>Contact Us for Best Accommodation Facilities | BRAC</title>
                <meta name="description" content="Do you have any questions about our accommodation
facilities that we did not answer in our FAQ section? Feel free to contact us. We'd
love to hear from you." />
                <meta name="keywords" content="Brac, Brac BLC, Brac BLC head office, BRAC BLC locations,
Learning center near me, BRAC International, About BLC" />
            </Helmet>
            <Hero_Section_Contact valHero={props.valContactData} />
            <Contact valLoc={props.valContactData} ></Contact>
            {/* <Blc_partner val={props.valPartner}></Blc_partner> */}
        </div>
    )
}

export default Blc_Contact
